export const cardImages = [
   { src: '/img/buffon.jpg' ,isMatch:false},
   { src: '/img/messi.jpg' ,isMatch:false},
   { src: '/img/pirlo.jpg',isMatch:false },
   { src: '/img/ronaldinho.jpg' ,isMatch:false},
   { src: '/img/ronaldo.jpg',isMatch:false},
   { src: '/img/salah.jpg' ,isMatch:false},
];
